var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseOperatorPanel = function SvgCloseOperatorPanel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.598 15.014q.297.049.644.049h13.516c1.64 0 2.453-.813 2.453-2.422V3.38l-1.258.881v8.316c0 .813-.437 1.227-1.21 1.227H4.324zM17.685.788a3.6 3.6 0 0 0-.927-.108H3.242C1.61.68.79 1.484.79 3.102v9.516l1.258-.88V3.164c0-.812.43-1.227 1.21-1.227h12.786z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.89 4.845A2 2 0 1 0 8.74 7.052l.89-.623a1 1 0 1 1 1.37-.96zM6.5 6a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M5.474 13H6a1 1 0 0 0 1-1v-.068zM6.489 8.627A1 1 0 0 0 6 8.5H4a1 1 0 0 0-1 1v1.57l1-.7V9.5h1.243zM8 11.232V12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V9.5a1 1 0 0 0-.393-.794l-1.134.794H11V12H9v-1.469z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13 9.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1V12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zm1 0h2V12h-2z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.99 14.31a.5.5 0 0 1 .122-.697L18.314 1.568a.5.5 0 1 1 .574.819L1.686 14.432a.5.5 0 0 1-.697-.123"
  })));
};
export default SvgCloseOperatorPanel;